import React from 'react';
import classNames from 'classnames';
import pluralize from '../../_utils/tools/pluralize';

export default function UploadFailureMessage({
  failedUploadCount,
  className = 'w-50 mx-auto mt-2',
}) {
  return (
    <div
      data-test-id="upload-failure-message"
      className={classNames('alert alert-danger p-2', className)}
      role="alert">
      <i className="fas fa-exclamation-circle fa-lg mr-2 text-danger" />
      {failedUploadCount} {pluralize('photo', failedUploadCount)} failed to
      upload
    </div>
  );
}
